"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Message/GateStatus.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');
var _broadcastTemplate = require('shared/services/broadcastTemplate');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _format = require('web/screens/Broadcast/format');









/* The first thing stopping the message from launching, or that it can. A
 * token that can never resolve is caught before the server answers. */
 const composerGateNotice = (
  template,
  fields,
  gate,
  limit,
) => {
  if (!template.trim()) return { kind: 'empty' }
  const unresolvable = _broadcastTemplateTokens.unresolvableTokens.call(void 0, _broadcastTemplateTokens.templateTokens.call(void 0, template), fields)[0]
  if (unresolvable) return { kind: 'undeclared', name: unresolvable.name }
  if (!gate) return null
  // Rev 35 E4: a blank first or last name counts too.
  const declared = new Set([...fields.map(f => f.Name), ..._broadcastTemplate.BUILT_IN_TEMPLATE_VARIABLES.map(b => b.Name)])
  const missing = gate.MissingVariables.find(v => declared.has(v.Name))
  if (missing) return { kind: 'missing', name: missing.Name, count: missing.Count }
  if (gate.TooLongCount > 0) return { kind: 'too_long', count: gate.TooLongCount, limit }
  if (!gate.TotalRecipients) return { kind: 'no_recipients' }
  return { kind: 'ready', total: gate.TotalRecipients }
}; exports.composerGateNotice = composerGateNotice















/* The status icon's state and tooltip. A token that can never resolve is
 * known without the server; everything else waits for the current check. */
 const gateStatus = (
  notice,
  isCurrent,
) => {
  if (!notice || notice.kind === 'empty') return null
  if (notice.kind === 'undeclared') {
    return {
      kind: 'blocked',
      text: `${notice.name} isn't a variable in this campaign. Nothing will replace it, so the launch is blocked.`,
    }
  }
  if (!isCurrent) return { kind: 'pending', text: 'Checking the message…' }
  switch (notice.kind) {
    case 'missing':
      return {
        kind: 'blocked',
        text: _broadcastTemplate.isBuiltInVariable.call(void 0, notice.name)
          ? `${_format.pluralize.call(void 0, notice.count, 'recipient has', 'recipients have')} no ${_broadcastTemplate.builtInLabel.call(void 0, notice.name)}. `
            + `Click {{${notice.name}}} in the message to give it a fallback, or they'll block Start.`
          : `${_format.pluralize.call(void 0, notice.count, 'recipient has', 'recipients have')} no value for ${notice.name}. `
            + `Click {{${notice.name}}} in the message to give it a default, or they'll block Start.`,
      }
    case 'too_long':
      return {
        kind: 'blocked',
        text: `${_format.pluralize.call(void 0, notice.count, 'recipient\'s message renders', 'recipients\' messages render')} over `
          + `${_format.formatCount.call(void 0, notice.limit)} characters. Shorten the message to launch.`,
      }
    case 'no_recipients':
      return { kind: 'info', text: 'No recipients are waiting to be sent this message yet.' }
    case 'ready':
      return { kind: 'ready', text: 'Every recipient has a value or a default. Nothing blocks Start.' }
  }
}; exports.gateStatus = gateStatus

const FAILED = {
  kind: 'info' ,
  text: "Couldn't check the message. The Send dialog checks it again before anything is sent.",
}

const ICONS = { ready: '✓', pending: '…', blocked: '!', info: 'i' }

/* Rev 35 E1: the chip's short text, shown beside the Message | Preview toggle
 * (the longer gateStatus text is its tooltip). Missing values aren't here:
 * the hint under the editor says them. */
 const gateChip = (
  notice,
  isCurrent,
  hasFailed,
  template,
) => {
  if (!template.trim()) return null
  if (_optionalChain([notice, 'optionalAccess', _ => _.kind]) === 'undeclared') {
    return { kind: 'blocked', label: `{{${notice.name}}} isn't a variable in this campaign`, title: _optionalChain([exports.gateStatus.call(void 0, notice, true), 'optionalAccess', _2 => _2.text]) }
  }
  if (hasFailed) return { kind: 'info', label: "Couldn't check the message", title: FAILED.text }
  if (!notice || !isCurrent) return { kind: 'pending', label: 'Checking…' }
  switch (notice.kind) {
    case 'missing':
      return null
    case 'too_long':
      return {
        kind: 'blocked',
        label: `${_format.pluralize.call(void 0, notice.count, 'message is', 'messages are')} over the ${_format.formatCount.call(void 0, notice.limit)} limit`,
        title: _optionalChain([exports.gateStatus.call(void 0, notice, true), 'optionalAccess', _3 => _3.text]),
      }
    case 'no_recipients':
      return { kind: 'info', label: 'No recipients yet' }
    case 'ready':
      return { kind: 'ready', label: `Ready for all ${_format.pluralize.call(void 0, notice.total, 'recipient', 'recipients')}` }
  }
  return null
}; exports.gateChip = gateChip

/* G1 (Rev 9), Rev 35 E1: the message's status as a chip with its text
 * showing, beside the Message | Preview toggle. The Send dialog still
 * enforces the gate. */
const GateStatus = ({ template, fields, gate, limit, isCurrent = true, hasFailed = false }) => {
  const notice = exports.composerGateNotice.call(void 0, template, fields, gate, limit)
  const chip = exports.gateChip.call(void 0, notice, isCurrent, hasFailed && _optionalChain([notice, 'optionalAccess', _4 => _4.kind]) !== 'undeclared', template)
  if (!chip) return null
  return (
    _react2.default.createElement('span', {
      role: "status",
      'aria-label': "Message status" ,
      title: chip.title,
      className: _classBuilder2.default.call(void 0, 'broadcast-gate-status', `broadcast-gate-status--${chip.kind}`), __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}

      , _react2.default.createElement('span', { className: "broadcast-gate-status--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}},  ICONS[chip.kind] )
      ,  chip.label 
    )
  )
}

exports. default = GateStatus
